var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGeneralFilterIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.25 17.125V8.75C15.25 7.7835 14.4665 7 13.5 7V7C12.5335 7 11.75 7.7835 11.75 8.75V17.1667C11.75 17.7076 11.9254 18.2339 12.25 18.6667L13.1 19.8C13.1944 19.9259 13.3426 20 13.5 20C13.6574 20 13.8056 19.9259 13.9 19.8L14.725 18.7C15.0658 18.2456 15.25 17.693 15.25 17.125V17.125Z",
    stroke: "#3378F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 22.5V9.5C25 8.11929 23.8807 7 22.5 7H22C21.4477 7 21 7.44772 21 8V19C21 19.5523 21.4477 20 22 20H22.5C23.8807 20 25 21.1193 25 22.5V22.5C25 23.8807 23.8807 25 22.5 25H8C6.89543 25 6 24.1046 6 23V13C6 11.8954 6.89543 11 8 11H9",
    stroke: "#3378F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11H21",
    stroke: "#3378F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGeneralFilterIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/GeneralFilterIcon.e0dc5f47.svg";
export { ForwardRef as ReactComponent };